"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.btnStyleActive = exports.btnStyle = void 0;
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _styled = _interopRequireDefault(require("@mui/material/styles/styled.js"));
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _Colors = _interopRequireDefault(require("../../styles/Colors"));
var _CommonSerializedStyles = require("../../internals/styles/CommonSerializedStyles");
var _Typography = _interopRequireDefault(require("../Typography"));
var _useTransformUnitUtils = require("../../hooks/useTransformUnitUtils");
var _excluded = ["size", "width", "height", "fullWidth", "margin", "padding", "label", "children", "intent", "isLoading", "icon", "startIcon", "endIcon", "variant", "sx", "disableTypography", "typographyProps"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/**
 * @since 3.0.0
 * @deprecated due to change in design and impl. approach
 */
var btnStyle = {
  primary: _Colors.default.orange,
  secondary: _Colors.default.textElementGrey,
  tertiary: 'transparent',
  success: _Colors.default.acceptGreen,
  warning: _Colors.default.warningRed
};

/**
 * @since 3.0.0
 * @deprecated due to change in design and impl. approach
 */
exports.btnStyle = btnStyle;
var btnStyleActive = {
  primary: '#B44C11',
  secondary: _Colors.default.black,
  tertiary: 'transparent',
  success: '#007400',
  warning: '#BE1327'
};
exports.btnStyleActive = btnStyleActive;
var ButtonWidth = {
  small: '32px',
  medium: '96px'
};
var ButtonHeight = {
  small: '32px',
  medium: '32px'
};
var pseudoClassElement = (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n"])));
var ButtonBase = (0, _react2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: inline-flex;\n    gap: 0 5px;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding: var(--padding);\n    margin: var(--margin);\n\n    &.Mui-disabled {\n        opacity: 0.5;\n        color: var(--color);\n        pointer-events: none;\n    }\n\n    & .MuiButton-startIcon,\n    & .MuiButton-endIcon {\n        margin: 0;\n    }\n\n    color: var(--color);\n    min-width: var(--width);\n    height: var(--height);\n\n    text-transform: none;\n"])));
var ContainedButtonBase = (0, _styled.default)(_Button.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    background-color: var(--bgColor);\n\n    &:hover {\n        background-color: var(--hoverBgColor);\n        ::before {\n            background-color: var(--hoverBeforeBgColor);\n            opacity: 0.2;\n            ", ";\n        }\n    }\n\n    &:active {\n        ::after {\n            border: 1px solid var(--activeAfterBorderColor);\n            box-sizing: border-box;\n            ", ";\n        }\n    }\n"])), ButtonBase, _CommonSerializedStyles.MuiBoxSizingWildcard, pseudoClassElement, pseudoClassElement);
var LinkButtonBase = (0, _styled.default)(_Button.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    &,\n    &:hover,\n    &:active {\n        text-decoration: underline;\n        background-color: transparent;\n    }\n\n    &:active {\n        opacity: 0.6;\n    }\n"])), ButtonBase, _CommonSerializedStyles.MuiBoxSizingWildcard);
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _theme$palette, _theme$palette2;
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 'medium' : _ref$size,
    widthProp = _ref.width,
    height = _ref.height,
    fullWidth = _ref.fullWidth,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 0 : _ref$margin,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '0 24px' : _ref$padding,
    label = _ref.label,
    children = _ref.children,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'default' : _ref$intent,
    isLoading = _ref.isLoading,
    icon = _ref.icon,
    startIconProp = _ref.startIcon,
    endIcon = _ref.endIcon,
    variant = _ref.variant,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    disableTypography = _ref.disableTypography,
    typographyProps = _ref.typographyProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0, _useTheme.default)();
  var _useTransformUnitUtil = (0, _useTransformUnitUtils.useTransformUnitUtils)(),
    transformUnitValue = _useTransformUnitUtil.transformUnitValue,
    transformUnitProps = _useTransformUnitUtil.transformUnitProps;
  var isLink = variant === 'text';
  var themeIntent = theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette2 = _theme$palette[intent]) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main;
  var ButtonToRender = isLink ? LinkButtonBase : ContainedButtonBase;
  var color = (0, _react.useMemo)(function () {
    if (intent === 'default' || intent === 'tertiary') {
      return _Colors.default.textElementGrey;
    }
    if (isLink) {
      return themeIntent;
    }
    return _Colors.default.white;
  }, [intent, isLink, themeIntent]);
  var bgColor = (0, _react.useMemo)(function () {
    if (intent === 'default') {
      return _Colors.default.lighterGrey;
    }
    if (intent === 'tertiary') {
      return 'transparent';
    }
    return themeIntent;
  }, [intent, themeIntent]);
  var hoverBgColor = (0, _react.useMemo)(function () {
    if (intent === 'tertiary') {
      return _Colors.default.lighterGrey;
    }
    return bgColor;
  }, [bgColor, intent]);
  var hoverBeforeBgColor = (0, _react.useMemo)(function () {
    if (intent === 'default') {
      return _Colors.default.grey;
    }
    return _Colors.default.white;
  }, [intent]);
  var activeAfterBorderColor = (0, _react.useMemo)(function () {
    if (intent === 'tertiary') {
      return _Colors.default.lightGrey;
    }
    return themeIntent || _Colors.default.grey;
  }, [intent, themeIntent]);
  var width = (0, _react.useMemo)(function () {
    if (fullWidth) {
      return '100%';
    }
    var widthValue = widthProp || sizeProp;
    return (ButtonWidth === null || ButtonWidth === void 0 ? void 0 : ButtonWidth[widthValue]) || transformUnitValue(widthValue);
  }, [fullWidth, widthProp, sizeProp, transformUnitValue]);
  var variablesSx = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({
      '--color': color,
      '--width': width
    }, transformUnitProps({
      '--height': height !== null && height !== void 0 ? height : ButtonHeight === null || ButtonHeight === void 0 ? void 0 : ButtonHeight[sizeProp],
      '--margin': margin,
      '--padding': padding
    })), {}, {
      '--bgColor': bgColor,
      '--hoverBgColor': hoverBgColor,
      '--hoverBeforeBgColor': hoverBeforeBgColor,
      '--activeAfterBorderColor': activeAfterBorderColor
    });
  }, [activeAfterBorderColor, bgColor, color, height, hoverBeforeBgColor, hoverBgColor, margin, padding, sizeProp, transformUnitProps, width]);
  var startIcon = (0, _react.useMemo)(function () {
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
        size: 18,
        sx: {
          color: color
        }
      });
    }
    return startIconProp || (icon === null || icon === void 0 ? void 0 : icon(color));
  }, [color, icon, isLoading, startIconProp]);
  var InnerWrapperComponent = (0, _react.useCallback)(function (_ref2) {
    var innerChildren = _ref2.children;
    if (disableTypography || !innerChildren) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, innerChildren);
    }
    return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
      variant: "button",
      color: "inherit",
      sx: {
        display: 'inherit',
        ':first-letter': {
          textTransform: 'uppercase'
        }
      }
    }, typographyProps), innerChildren);
  }, [disableTypography, typographyProps]);
  return /*#__PURE__*/_react.default.createElement(ButtonToRender, _extends({
    sx: _objectSpread(_objectSpread({}, variablesSx), sx),
    startIcon: startIcon,
    endIcon: endIcon
  }, rest, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(InnerWrapperComponent, null, label || children));
});
var _default = Button;
exports.default = _default;